import { render, staticRenderFns } from "./LabDetails.vue?vue&type=template&id=1e86f3d2&scoped=true&"
import script from "./LabDetails.vue?vue&type=script&lang=js&"
export * from "./LabDetails.vue?vue&type=script&lang=js&"
import style0 from "./LabDetails.vue?vue&type=style&index=0&id=1e86f3d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e86f3d2",
  null
  
)

export default component.exports